export default "__VITE_ASSET__Dm$YeJV$__"